import { Controller } from "@hotwired/stimulus"

// Resets form after successful Turbo submission
export default class extends Controller {
  connect() {
    console.log("Reset form controller connected")
  }

  reset(event) {
    // Only reset on successful submission
    if (event.detail.success) {
      // Reset the form
      this.element.reset()
      
      // Reset any textareas to their original height
      const textareas = this.element.querySelectorAll('textarea')
      textareas.forEach(textarea => {
        textarea.style.height = 'auto'
        textarea.style.height = textarea.scrollHeight + 'px'
      })
      
      // Clear any error messages
      const errors = this.element.querySelectorAll('.field_with_errors')
      errors.forEach(error => {
        error.classList.remove('field_with_errors')
      })
    }
  }
}